import React from "react";

export const CheckboxChecked = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4353_47909)">
        <rect
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="1.5"
          fill="#A100FF"
          stroke="#A100FF"
        />
        <mask
          id="mask0_4353_47909"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4353_47909)">
          <path
            d="M9.54998 17.2749C9.43332 17.2749 9.32098 17.2539 9.21298 17.2119C9.10432 17.1706 9.00832 17.1082 8.92498 17.0249L4.74998 12.8499C4.59998 12.6999 4.52898 12.5206 4.53698 12.3119C4.54565 12.1039 4.61665 11.9249 4.74998 11.7749C4.89998 11.6249 5.07932 11.5499 5.28798 11.5499C5.49598 11.5499 5.66665 11.6249 5.79998 11.7749L9.54998 15.5249L18.2 6.8749C18.3333 6.7249 18.5083 6.6499 18.725 6.6499C18.9417 6.6499 19.1167 6.7249 19.25 6.8749C19.4 7.0249 19.475 7.2039 19.475 7.4119C19.475 7.62057 19.4 7.7999 19.25 7.9499L10.175 17.0249C10.0917 17.1082 9.99598 17.1706 9.88798 17.2119C9.77932 17.2539 9.66665 17.2749 9.54998 17.2749Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4353_47909">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckboxChecked;
